export class ResponseAPI<T> {
  ResponseStatus = 0;
  ResponseDescription = '';
  ResponseObject: T | null = null;

  get Success(): boolean {
    return this.ResponseStatus >= 200 && this.ResponseStatus < 300;
  }

  get Message(): string {
    return this.ResponseDescription;
  }

  get ObjectResponse(): T | null {
    return this.ResponseObject;
  }
}
